// import { makeStyles } from '@mui/material/styles'
import { makeStyles } from '@mui/styles';

const drawerWidth = 240

const useStyles = makeStyles(() => ({
  appMenu: {
    width: '100%',
    fontSize: "12px",
    listStyleType: "none",
    margin: 0,
    padding: 0,
    borderBottom: "1px solid rgba(255,255,255,.08)",
  },
  navList: {
    width: drawerWidth,
  },
  menuItem: {
    width: drawerWidth,
    "&&": {
      padding: "9px 12px",
      borderTop: "1px solid rgba(255,255,255,.08)",
      minHeight: 42,
    },
  },
  row: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "8px",
  },
  plus: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: "#bdbdbd",
  },
  countryName: {
    flex: 1,
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  countryCount: {
    textAlign: "right",
    fontSize: "13px",
    whiteSpace: "nowrap",
    marginLeft: "auto",
  },
  menuItemIcon: {
    color: '#97c05c',
  },
  countryList: {
    paddingTop: 10, color: "#d8d8de", "& span, & div": { color: "#d8d8de" },
  },
  continent: {
    fontSize: "14px",
    color: "#cb2845",
    fontWeight: 900,
    margin: "0 10px 10px",
    padding: 0,
    textTransform: "uppercase",
    "&:not(:first-child)": { marginTop: 20 },
  }
}));

export { useStyles };
